import { inquiryTypeIdAtom } from '@activities/customerService/InquiryActivity/atoms/inquiryFormAtoms';
import useInquiryTypes from '@activities/customerService/InquiryActivity/components/InquiryWriteForm/hooks/useInquiryTypes';
import Button from '@components/Button';
import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useAtom } from 'jotai';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        InquiryTypeBottomSheet: {};
    }
}

/** 1:1 문의 유형 선택. 확인을 눌러야 폼에 반영된다. */
const InquiryTypeBottomSheet: ActivityComponentType<'InquiryTypeBottomSheet'> = () => {
    const { t } = useTranslation('inquiry');
    const { pop } = useFlow();
    const inquiryTypes = useInquiryTypes();
    const [inquiryTypeId, setInquiryTypeId] = useAtom(inquiryTypeIdAtom);
    const [selected, setSelected] = useState<string>(inquiryTypeId);
    const handleConfirm = () => {
        setInquiryTypeId(selected);
        pop();
    };
    return (
        <BottomSheet>
            <Header>
                <Text size='title' fontWeight='bold' color='var(--color-text-primary)'>
                    {t('form.typeListTitle')}
                </Text>
            </Header>
            <Options fullWidth>
                {inquiryTypes?.map((inquiryType) => (
                    <Option key={inquiryType.inquiryTypeId}>
                        <Radio value={inquiryType.inquiryTypeId}
                            isSelected={selected === inquiryType.inquiryTypeId}
                            onChange={setSelected}>
                            {inquiryType.name}
                        </Radio>
                    </Option>
                ))}
            </Options>
            <Footer>
                <Button fullWidth
                    disabled={!selected}
                    onClick={handleConfirm}>
                    {t('form.confirm')}
                </Button>
            </Footer>
        </BottomSheet>
    );
};

const Header = styled.div`
    align-items: center;
    display: flex;
    height: 64px;
    justify-content: center;
`;

const Options = styled(Column)`
    max-height: 60vh;
    overflow-y: auto;
    padding: var(--spacing-2) var(--spacing-4);
`;

const Option = styled.div`
    padding: var(--spacing-2) 0;
    width: 100%;
`;

const Footer = styled.div`
    padding: var(--spacing-4) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
`;

export default InquiryTypeBottomSheet;
